import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import DashboardService from "../../../core/services/dashboardService.js";
import WidgetService from "../../../core/services/widgetService.js";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator.js";
import WidgetType from "../../../core/constants/widgetType.js";

import Select from 'react-select';

const moment = require('moment-timezone');
import { variableTypes } from "./selection-contorl/constants";

import styles from "./styles.scss";

export class AddControlWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.dashboardState = [];
    this.state = this.getInitialState();
  }

  componentDidMount() {
    this.$modal = $("#add-control-widget");
    this.$modal.modal({
      dismissible: false
    });
    $(this.refs.container).find("select").material_select();
    $(this.refs.inputType).on("change", (e) => this.handleChange("inputType", e));
    $(this.refs.variableType).on("change", (e) => this.handleChange("variableType", e));
  }

  componentDidUpdate() {
    $(this.refs.container).find("select").material_select();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.editControlWidget) {
      const metaData = nextProps.editControlWidget.metaData;
      const variable = DashboardService.getCurrentDashboardVariableById(metaData.variable.id);
      if (variable) {
        this.setState({
          title: metaData.title,
          variableId: variable.id,
          variableType: variable.type,
          variableName: variable.name || "",
          defaultValue: variable.value,
          editMode: true,
          visibleExp: metaData.visible ? metaData.visible.expression : "",
          dateTimeFormat: variable.dateTimeFormat
        });
      }
    } else {
      this.setState(this.getInitialState());
    }
  }

  getInitialState() {
    return {
      title: "",
      error: "",
      editMode: false,
      variableId: UniqueIdGenerator.id(),
      variableName: "",
      variableType: null,
      defaultValue: "",
      visibleExp: "",
      dateTimeFormat: ""
    };
  }

  addOrUpdate() {
    const error = this.validate();
    if (error) {
      this.setState({
        error: error
      });
    } else {
      const variable = {
        id: this.state.variableId,
        type: this.state.variableType,
        name: this.state.variableName,
        defaultValue: this.state.defaultValue,
        value: this.state.defaultValue || null,
        dateTimeFormat: this.state.dateTimeFormat
      };
      const metaData = {
        type: "input",
        title: this.state.title,
        variable,
        visible: {
          type: variableTypes.EXPRESSION,
          expression: this.state.visibleExp
        }
      };

      if (this.state.variableType === variableTypes.DATE ||
        this.state.variableType === variableTypes.TIME ||
        this.state.variableType === variableTypes.DATETIME) {
        const date = moment();
        date.set("hour", 0);
        date.set("minute", 0);
        date.set("second", 0);
        date.set("millisecond", 0);
        variable.timezone = moment.tz.guess();
        variable.value = date.toISOString();
      }

      if (this.state.editMode) {
        const widget = this.checkDuplicatedControlWidget(this.state.variableName);
        if (widget && widget.id !== this.props.editControlWidget.id) {
          this.setState({
            error: "Variable name already in use"
          });
        } else {
          this.addOrUpdateDashboardVariable(variable)
            .then(() => {
              const widgetId = this.props.editControlWidget.id;
              WidgetService.updateWidgetMetaData(widgetId, metaData);
              this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, [metaData.variable]);
              this.publish(InternalEvent.Dashboard.CONTROL_UPDATED, { widgetId });
              this.hide();
            });
        }
      } else {
        this.addOrUpdateDashboardVariable(variable)
          .then(() => {
            this.publish(InternalEvent.Dashboard.CONTROL_ADDED, metaData);
            this.hide();
          });
      }
    }
  }

  addOrUpdateDashboardVariable(variable) {
    const variables = {};
    variables[variable.id] = variable;
    return DashboardService.updateDashboardVariables(variables)
  }

  validate() {
    let error = null;
    if (this.state.variableName.trim().length === 0) {
      error = "Type a variable name";
    }
    if (!error && this.state.variableType === null) {
      error = "Select a variable type";
    }
    return error;
  }

  show() {
    DashboardService.getCurrentDashboard()
      .then(dashboard => {
        this.dashboardState = dashboard.state.dashboardState;
        this.setState({
          variables: dashboard.variables
        });
        this.$modal.modal("open");
        Materialize.updateTextFields();
      });
  }

  checkDuplicatedControlWidget(variableName) {
    const widgetModels = this.dashboardState.map(s => s.widgetModel);
    const widget = widgetModels.find(widget =>
      widget.type === WidgetType.CONTROL_WIDGET && widget.metaData.variableName === variableName);
    return widget;
  }

  hide() {
    this.$modal.modal("close");
    this.setState(this.getInitialState());
  }

  handleChange(field, value) {
    const newState = this.copyState();
    newState.error = "";
    newState[field] = value;
    if (field === "timezone" && (value === "4" || value === "5")) {
      newState.timezone = moment.tz.guess();
    }
    if (field === "variableType") {
      newState.defaultValue = "";
    }
    if (field === "defaultValue" && this.state.type === variableTypes.NUMBER) {
      newState[field] = parseFloat(value);
    }
    this.setState(newState);
  }

  render() {
    let error;
    let defaultValueInput;
    let dateTimeFormat;
    if (this.state.error) {
      error = <div className={styles.error}>{this.state.error}</div>
    }

    const variableTypeOptions = [];
    for (let prop in variableTypes) {
      variableTypeOptions.push({ value: variableTypes[prop], label: prop });
    }

    if (this.state.variableType !== variableTypes.DATE &&
      this.state.variableType !== variableTypes.DATETIME &&
      this.state.variableType !== variableTypes.TIME) {
      defaultValueInput = <div className="input-field col s12">
        <input type="text" value={this.state.defaultValue} name="defaultValue"
          onChange={e => this.handleChange("defaultValue", e.target.value)} />
        <label htmlFor="defaultValue">Default Value</label>
      </div>;
    } else {
      dateTimeFormat = <div className="input-field col s12">
      <input type="text" value={this.state.dateTimeFormat} name="dateTimeFormat"
        onChange={e => this.handleChange("dateTimeFormat", e.target.value)} />
      <label htmlFor="dateTimeFormat">DateTime Format</label>
    </div>;
    }

    return (
      <div className={["modal", styles.modalContainer].join(" ")} id="add-control-widget" ref="container">
        <div className="modal-content">
          <h4 className={styles.title}>{this.state.editMode ? "Edit Control Widget" : "Add Control Widget"}</h4>
          {error}
          <div className="row">
            <div className="input-field col s12" style={{ width: "300px" }}>
              <input id="widget-title" type="text"
                value={this.state.title}
                onChange={e => this.setState({ title: e.target.value })} />
              <label htmlFor="widget-title">Widget Title</label>
            </div>
            <div className="input-field col s12">
              <input type="text" value={this.state.variableName} name="variableName"
                onChange={e => this.handleChange("variableName", e.target.value)} />
              <label htmlFor="variableName">Variable Name</label>
            </div>
            <div className="input-field col s12">
              <input type="text" value={this.state.visibleExp} name="visibleExp"
                onChange={e => this.setState({ visibleExp: e.target.value })} />
              <label htmlFor="visibleExp">Visibility</label>
            </div>
            <div className="input-field col s12">
              <div className={styles.label}>Variable Type</div>
              <Select
                className={styles.select}
                name="variable-type"
                value={this.state.variableType}
                options={variableTypeOptions}
                onChange={(option) => this.handleChange("variableType", option.value)} />
            </div>
            {dateTimeFormat}
            {defaultValueInput}
          </div>
        </div>
        <div className="modal-footer">
          <a className="waves-effect waves-light btn-flat"
            onClick={this.addOrUpdate}>{this.state.editMode ? "Update" : "Add"}</a>
          <a className="waves-effect btn-flat" onClick={this.hide}>Cancel</a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/add-control-widget.jsx